import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Itprojectstable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.itprojectstable_Id,
          sortable: true,
          cell: (row) => <span>{row.itprojectstable_Id}</span>,
        },
        {
          name: "Project Name",
          selector: (row, i) => row.projectName,
          sortable: true,
          cell: (row) => <span>{row.projectName}</span>,
        },
        {
          name: "Project Owner",
          selector: (row, i) => row.projectOwner,
          sortable: true,
          cell: (row) => <span>{row.projectOwner}</span>,
        },
        {
          name: "Project Start Date",
          selector: (row, i) => row.projectStartDate,
          sortable: true,
          cell: (row) => <span>{row.projectStartDate}</span>,
        },
        {
          name: "Project End Date",
          selector: (row, i) => row.projectEndDate,
          sortable: true,
          cell: (row) => <span>{row.projectEndDate}</span>,
        },
        {
          name: "Color Code",
          selector: (row, i) => row.colorCode,
          sortable: true,
          cell: (row) => <span>{row.colorCode}</span>,
        },

        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ItprojectstableeditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      itprojectstable_Id: "",
      projectName: "",
      colorCode: "",
      employees: [],
      projectOwner: "",
      projectStartDate: "",
      projectEndDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFive: "",
      createDeploymentProject: false,
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      projectName: "",

      projectOwner: "",
      projectStartDate: "",
      projectEndDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFive: "",
      createDeploymentProject: false,
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      projectName: "",
      colorCode: "",
      projectOwner: "",
      projectStartDate: "",
      projectEndDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFive: "",
      createDeploymentProject: false,
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  ItprojectstableeditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true,
      itprojectstable_Id: row.itprojectstable_Id,
      projectName: row.projectName,
      colorCode: row.colorCode,
      projectOwner: row.projectOwner,
      projectStartDate: row.projectStartDate,
      projectEndDate: row.projectEndDate,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      dummyFive: row.dummyFive, //***editstate
    });
  };

  ItprojectstablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Itprojectstable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  ItprojectstablesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("projectName", this.state.projectName);
    formData.append("projectOwner", this.state.projectOwner);
    formData.append("projectStartDate", this.state.projectStartDate);
    formData.append("projectEndDate", this.state.projectEndDate);
    formData.append("colorCode", this.state.colorCode);
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFive", "");
    formData.append("createDeploymentProject", this.state.createDeploymentProject ? "1" : "0");

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Itprojectstable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ItprojectstablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            projectName: "",
            employees: [],
            projectOwner: "",
            projectStartDate: "",
            projectEndDate: "",
            colorCode: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFive: "",
            createDeploymentProject: false,
          });
        }

        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  ItprojectstableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("itprojectstable_Id", this.state.itprojectstable_Id);
    formData.append("projectName", this.state.projectName);
    formData.append("projectOwner", this.state.projectOwner);
    formData.append("projectStartDate", this.state.projectStartDate);
    formData.append("projectEndDate", this.state.projectEndDate);
    formData.append("colorCode", this.state.colorCode);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFive", this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Itprojectstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ItprojectstablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.ItprojectstablefetchHandler();
    this.employeesfetchHandler();

    //***componentDidMount
  }
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ projectName: fieldValue });
  };
  handleprojectOwnerChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ projectOwner: fieldValue });
  };
  employeesfetchHandler = () => {
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  handleprojectStartDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ projectStartDate: fieldValue });
  };
  handleprojectEndDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ projectEndDate: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handlecolorCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ colorCode: fieldValue });
  };

  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    formData.append("itprojectstable_Id", row.itprojectstable_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Itprojectstable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ItprojectstablefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        IT Projects
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title> Add IT Projects </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleprojectNameChange}
                                        className="form-control"
                                        name="projectName"
                                        value={this.state.projectName}
                                        required="required"
                                        placeholder="Enter Project Name"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.projectName}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Owner
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select
                                        className="form-select"
                                        name="projectOwner"
                                        value={this.state.projectOwner}
                                        onChange={this.handleprojectOwnerChange}
                                      >
                                        <option defaultValue>
                                          Select Project Owner
                                        </option>
                                        {this.state.employees.map(
                                          (api, index, idx) => (
                                            <option
                                              key={index}
                                              value={api.employees_Id}
                                            >
                                              {api.fName}&nbsp;{api.lName}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.projectOwner}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project Start Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleprojectStartDateChange
                                        }
                                        className="form-control"
                                        name="projectStartDate"
                                        value={this.state.projectStartDate}
                                        required="required"
                                        placeholder="Enter Project Start Date"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.projectStartDate}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Project End Date
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleprojectEndDateChange
                                        }
                                        className="form-control"
                                        name="projectEndDate"
                                        value={this.state.projectEndDate}
                                        required="required"
                                        placeholder="Enter Project End Date"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.projectEndDate}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="color"
                                        onChange={this.handlecolorCodeChange}
                                        className="form-control"
                                        name="colorCode"
                                        value={this.state.colorCode}
                                        required="required"
                                      //  placeholder="Enter Dummy One"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.dummyOne}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy One
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter Dummy One"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.dummyOne}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter Dummy Two"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.dummyTwo}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Four
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyThreeChange}
                                        className="form-control"
                                        name="dummyThree"
                                        value={this.state.dummyThree}
                                        required="required"
                                        placeholder="Enter Dummy Four"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.dummyThree}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Five
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFiveChange}
                                        className="form-control"
                                        name="dummyFive"
                                        value={this.state.dummyFive}
                                        required="required"
                                        placeholder="Enter Dummy Five"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.dummyFive}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="12" md="12">
                                      <Form.Check
                                        type="checkbox"
                                        label="Also create as Deployment Project"
                                        checked={this.state.createDeploymentProject}
                                        onChange={(e) =>
                                          this.setState({ createDeploymentProject: e.target.checked })
                                        }
                                      />
                                      <Form.Text className="text-muted">
                                        Creates a linked project in the Deployment module automatically.
                                      </Form.Text>
                                    </Col>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ItprojectstablesubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit IT Project's</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleprojectNameChange
                                          }
                                          className="form-control"
                                          name="projectName"
                                          value={this.state.projectName}
                                          required="required"
                                          placeholder="Enter Project Name"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.projectName}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Owner
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="projectOwner"
                                          value={this.state.projectOwner}
                                          onChange={
                                            this.handleprojectOwnerChange
                                          }
                                        >
                                          <option defaultValue>
                                            Select Project Owner
                                          </option>
                                          {this.state.employees.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.employees_Id}
                                              >
                                                {api.fName}&nbsp;{api.lName}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.projectOwner}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project Start Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleprojectStartDateChange
                                          }
                                          className="form-control"
                                          name="projectStartDate"
                                          value={this.state.projectStartDate}
                                          required="required"
                                          placeholder="Enter Project Start Date"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.projectStartDate}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Project End Date
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleprojectEndDateChange
                                          }
                                          className="form-control"
                                          name="projectEndDate"
                                          value={this.state.projectEndDate}
                                          required="required"
                                          placeholder="Enter Project End Date"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.projectEndDate}
                                      </div>
                                    </Row>

                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Color Code
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="color"
                                          onChange={this.handlecolorCodeChange}
                                          className="form-control"
                                          name="colorCode"
                                          value={this.state.colorCode}
                                          required="required"
                                        //  placeholder="Enter Dummy One"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy One
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyOneChange}
                                          className="form-control"
                                          name="dummyOne"
                                          value={this.state.dummyOne}
                                          required="required"
                                          placeholder="Enter Dummy One"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.dummyOne}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Two
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyTwoChange}
                                          className="form-control"
                                          name="dummyTwo"
                                          value={this.state.dummyTwo}
                                          required="required"
                                          placeholder="Enter Dummy Two"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.dummyTwo}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Four
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyThreeChange}
                                          className="form-control"
                                          name="dummyThree"
                                          value={this.state.dummyThree}
                                          required="required"
                                          placeholder="Enter Dummy Four"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.dummyThree}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Five
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyFiveChange}
                                          className="form-control"
                                          name="dummyFive"
                                          value={this.state.dummyFive}
                                          required="required"
                                          placeholder="Enter Dummy Five"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {this.state.errors.dummyFive}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ItprojectstableupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
